import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export const isFetchBaseQueryError = (
  error: any
): error is FetchBaseQueryError => {
  return (
    typeof error === "object" &&
    "status" in error &&
    "data" in error &&
    "message" in error.data
  );
};
